import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
	const { user, isAuthenticated } = useAuth();
	const { tenantId } = useParams();

	if (!isAuthenticated) {
		// Redirect to tenant-specific login or default
		const loginPath = tenantId ? `/${tenantId}` : '/default';
		return <Navigate to={loginPath} replace />;
	}

	if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
		// Redirect to tenant-specific login or default
		const loginPath = tenantId ? `/${tenantId}` : '/default';
		return <Navigate to={loginPath} replace />;
	}

	return children;
};

export default ProtectedRoute;
